module.exports = __webpack_public_path__ + "img/new_index_industry_icon5.184b4ab9.png";